<template>
  <section class="section">
    <Loader :isLoading="this.isLoading"></Loader>

    <div v-if="!isLoading" class="section">
      <div class="columns is-multiline">
        <div class="column is-3-desktop is-4-tablet is-12-mobile flex-column"
             v-for="(generalBestPractice, generalBestPracticeNumber) in generalBestPractices"
             :key="generalBestPractice.sys.id">
          <GeneralBestPracticeSummaryCard :generalBestPractice="generalBestPractice" :topicIcon="topicIcon" :generalBestPracticeNumber="generalBestPracticeNumber + 1" :generalBestPracticeCount="(generalBestPractices || []).length"></GeneralBestPracticeSummaryCard>
        </div>
        <div class="column is-3-desktop is-4-tablet is-12-mobile flex-column"
             v-for="bestPractice in bestPractices"
             :key="bestPractice.sys.id">
          <BestPracticeSummaryCard :bestPractice="bestPractice"></BestPracticeSummaryCard>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  /* Services */
  import Contentful from '@/services/Contentful'

  /* Components */
  import GeneralBestPracticeSummaryCard from '@/components/BestPractice/GeneralBestPracticeSummaryCard'
  import BestPracticeSummaryCard from '@/components/BestPractice/BestPracticeSummaryCard'
  import Loader from '@/components/General/Loader'

  export default {
    data () {
      return {
        bestPracticeTopic: {},
        bestPractices: [],
        generalBestPractices: [],
        topicIconUrl: '',
        isLoading: true
      }
    },
    async mounted () {
      /* Get Id */
      const bestPracticeTopicId = this.$store.state.route.params.bestPracticeTopicId

      /* Get topic */
      this.bestPracticeTopic = (await Contentful.getBestPracticeTopic(bestPracticeTopicId)).data
      this.bestPractices = this.bestPracticeTopic.fields.bestPractices || []
      this.generalBestPractices = this.bestPracticeTopic.fields.generalBestPractices || []
      this.topicIcon = this.bestPracticeTopic.fields.icon || {}
      this.isLoading = false
      /* Scroll to top */
      window.scrollTo(0, 0)
    },
    components: {
      BestPracticeSummaryCard,
      GeneralBestPracticeSummaryCard,
      Loader
    }
  }
</script>

<style scoped>
  .flex-column {
    display: flex;
  }
  .section {
    padding: 0.8rem 1.5rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/ViewBestPracticeTopic.vue